<template>
	<b-card title="机器人说明" no-body>
		<b-card-header header-tag="nav">
			<b-nav card-header tabs>
				<b-nav-item to="/robot/hot" exact exact-active-class="active">常用说明</b-nav-item>
				<b-nav-item to="/robot/vip" exact exact-active-class="active">高级说明</b-nav-item>
				<b-nav-item to="/robot/base" exact exact-active-class="active">基础说明</b-nav-item>
			</b-nav>
		</b-card-header>
		<b-card-body>
			<router-view></router-view>
		</b-card-body>
	</b-card>
</template>

<script>
	
	export default {
		data() {
			return {
			}
		},
		components: {
			// SentimentMarketHotTrend
		},
		methods: {

		}
	}
</script>

<style>
</style>
